
import React from 'react';

const UpArrowSVG = ({className}) => {
    return (
        <svg viewBox="0 0 24 24" className={className}>
            <path d="M12.354 0.146c-0.195-0.195-0.512-0.195-0.707 0l-9.5 9.5c-1.024 1.024-1.024 2.683 0 3.707s2.683 1.024 3.707 0l3.646-3.646v11.793c0 1.381 1.119 2.5 2.5 2.5s2.5-1.119 2.5-2.5v-11.793l3.646 3.646c1.024 1.024 2.683 1.024 3.707 0s1.024-2.683 0-3.707l-9.499-9.5z"></path>
        </svg>
    );
}

export default UpArrowSVG;
